import { useReducer } from 'react';
import { configs } from '../constants/configs/configs';
import { USER_PROFILE } from '../constants/common/statusTypes';
import axios from 'axios';


const actions = {
    POST_RESET_PWD_SUCCESS : 'POST_RESET_PWD_SUCCESS',
    POST_RESET_PWD_ERROR : 'POST_RESET_PWD_ERROR',
    POST_UNBLOCK_USER_SUCCESS : 'POST_UNBLOCK_USER_SUCCESS',
    POST_UNBLOCK_USER_ERROR : 'POST_UNBLOCK_USER_ERROR',
    POST_RESET_PWD_ALTERNATE_EMAIL: 'POST_RESET_PWD_ALTERNATE_EMAIL'
};

const api = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': window.EMAIL,
        'X-Requested-With' : 'XMLHttpRequest',
        'csrftoken': window.csrf_token
    }
});

function reducer(state, { type, payload }) {
    switch (type) { 
        case actions.POST_RESET_PWD_SUCCESS:
            return {
                ...state,
                resetPwdResponse: payload,
            };  
        case actions.POST_RESET_PWD_ERROR:
            return {
                ...state,
                resetPwdResponse: payload,
            }; 
        case actions.POST_UNBLOCK_USER_SUCCESS:
            return {
                ...state,
                unblockUserResponse: payload,
            };  
        case actions.POST_UNBLOCK_USER_ERROR:
            return {
                ...state,
                unblockUserResponse: payload,
            }; 
        case actions.POST_RESET_PWD_ALTERNATE_EMAIL:
            return {
                ...state,
                resetPwdAlternateEmail: true,
            }; 
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, {
        resetPwdResponse:undefined,
        unblockUserResponse: undefined,
        resetPwdAlternateEmail: undefined
    });

    const resetPassword = async (hhid : any) => {
        var formData = new FormData();
        formData.append('householdId', hhid);
        api.post(
            configs.endpoints.RESET_PASSWORD , formData
        ).then(response => {
            if (response.data?.STATUS === 'OK') {
                if (response.data.OVERRIDE_EMAIL) {
                    dispatch({ type: actions.POST_RESET_PWD_SUCCESS, payload: response.data });
                }
                else {
                    alert("An email has been sent to: "+ response.data.EMAIL_ID +". Please check your inbox, and click on the link in the message.");
                }
                
            }
            else{
                alert("Unable to send reset password email");	
            }
        })
            .catch((error) => {
                dispatch({ type: actions.POST_RESET_PWD_ERROR, payload: error });
                alert("Unable to send reset password email");	
            });
    };
    const unblockUser = async (hhid : any, idmUserStatus: any) => {
        var formData = new FormData();
        formData.append('householdId', hhid);
        api.post(
            configs.endpoints.UNLOCK_USER , formData
        ).then(() => {
            dispatch({ type: actions.POST_UNBLOCK_USER_SUCCESS, payload: true});
            if(idmUserStatus !== USER_PROFILE.LOCKED) {
                alert("Account reactivated successfully.");
            }
        })
            .catch(() => {
                dispatch({ type: actions.POST_UNBLOCK_USER_ERROR, payload: false });
                alert("Unable to unlock account");
            });
    };
    const resetPassowrdAlternateEmail = async (hhid : string, data : any) => {
        var formData = new FormData();
        formData.append('householdId', hhid);
        formData.append('alternateEmail', data.alternateEmail);
        formData.append('emailType', data.email);
        formData.append('reason', data.reason);
        api.post(
            configs.endpoints.RESET_PASSWORD_ALTERNATE_EMAIL , formData
        ).then(response => {
            dispatch({ type: actions.POST_RESET_PWD_ALTERNATE_EMAIL, payload:{'OVERRIDE_EMAIL' : true}});
            if (response.data.STATUS === 'OK') {
                alert("An email has been sent to: "+ response.data.EMAIL_ID +". Please check your inbox, and click on the link in the message.");
            }
            if (response.data.STATUS === 'ERROR') {
                    alert("Unable to send reset password email");	
            }
        })
        .catch((error) => {
            dispatch({ type: actions.POST_RESET_PWD_ALTERNATE_EMAIL, payload:{'OVERRIDE_EMAIL' : true}});
            alert("Unable to send reset password email");	
        });
    };

    return {
        ...data,
        resetPassword: (data) => {
            resetPassword(data);
        },
        unblockUser: (hhid, idmUserStatus) => {
            unblockUser(hhid, idmUserStatus);
        },
        resetPassowrdAlternateEmail: (hhid, data) => {
            resetPassowrdAlternateEmail(hhid, data);
        },
    };
};